import { ReactNode, createContext, useEffect, useState } from 'react';
import { CustomActivityConfig } from '../types/CustomActivityConfig.types';
import connection from '../utils/postmonger';
import { Overlay } from '../components/common/Overlay';
import {
  SampleDataRequestedTriggerEventDefinition,
  TempInitConfig,
  TempRequestedInteraction,
} from './tempInitConfig';

interface CustomActivityContextProviderProps {
  children: ReactNode;
}

type CustomActivityType = {
  activityConfig: CustomActivityConfig | null;
  setActivityConfig: React.Dispatch<
    React.SetStateAction<CustomActivityConfig | null>
  >;
  journeyId: string | null;
  activityKey: string | null;
  eventDefinitionKey: string | null;
  journeyVersion: number | null;
  showAlertToClose: string | null;
};

export const CustomActivityContext = createContext({} as CustomActivityType);

const CustomActivityContextProvider = ({
  children,
}: CustomActivityContextProviderProps) => {
  const [activityConfig, setActivityConfig] =
    useState<CustomActivityConfig | null>(null);
  const [activityKey, setActivityKey] = useState<string | null>(null);
  const [journeyId, setJourneyId] = useState<string | null>(null);
  const [eventDefinitionKey, setEventDefinitionKey] = useState<string | null>(
    null,
  );
  const [journeyVersion, setJourneyVersion] = useState<number | null>(null);
  const [showAlertToClose, setShowAlertToClose] = useState<string | null>(null);

  // !! BELOW FOR DEV ONLY !!
  useEffect(() => {
    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      setActivityConfig(TempInitConfig);
    }
  }, []);

  useEffect(() => {
    // console.log('***starting app***');

    let checkJourneyId = '';
    let checkActivityKey = '';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    connection.on('initActivity', function (data: any) {
      console.log('================= initActivity ===============');
      // check TempInitConfig to see what data looks like
      console.log(data);
      setActivityKey(data.key);
      setActivityConfig(data);
      checkActivityKey = data.key;
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    connection.on('requestedTriggerEventDefinition', (data: any) => {
      console.log('=====data from requestedTriggerEventDefinition');
      console.log(data);
      setEventDefinitionKey(data.eventDefinitionKey);
      // console.log('eventDefinitionKey:', activityKey);
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestedInteractionHandler = (settings: any) => {
      console.log('============requestedInteractionHandler=============');
      console.log(settings);
      try {
        checkJourneyId = settings.id;

        // const journeyName = settings.name;

        setJourneyId(checkJourneyId);
        setJourneyVersion(settings.version);

        if (!settings.triggers[0]?.metaData?.eventDefinitionKey) {
          setShowAlertToClose('Please first setup an Entry Source.');
        } else if (!checkJourneyId || !checkActivityKey) {
          setShowAlertToClose('Please save the journey to proceed.');
        }
      } catch (e) {
        console.error(e);
      }
    };

    connection.on('requestedInteraction', requestedInteractionHandler);

    connection.trigger('requestSchema');

    /**
     * If the response code is 200 (OK),
     * Journey Builder fires requestedInteraction.
     * Returns complete journey settings data with all active activities configs etc
     * See SampleDataRequestedInteractionHandler
     */
    connection.trigger('requestInteraction');

    /**
     * If the response code is 200 (OK),
     * Journey Builder fires requestedTriggerEventDefinition.
     * See SampleDataRequestedTriggerEventDefinition
     */
    connection.trigger('requestTriggerEventDefinition');

    // !! BELOW FOR DEV ONLY !!
    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      console.log(
        '===prefill localhost data with stuff from tempInitConfig.ts===',
      );
      console.log(TempInitConfig);
      setActivityConfig(TempInitConfig);
      setJourneyId(TempRequestedInteraction.id);
      setActivityKey(TempInitConfig.key);
      setEventDefinitionKey(
        SampleDataRequestedTriggerEventDefinition.eventDefinitionKey,
      );
    }
  }, []);

  /** Need to check journey version?? */
  // useEffect(() => {
  //   if (
  //     journeyVersion &&
  //     savedActivityData &&
  //     savedActivityData.journeyVersion &&
  //     journeyVersion !== savedActivityData.journeyVersion
  //   ) {
  //     setShowAlertToClose(
  //       'This is a new version of the current journey. Please save the journey first before making modifications.',
  //     );
  //   }
  // }, [savedActivityData, journeyVersion]);

  const value = {
    activityConfig,
    setActivityConfig,
    journeyId,
    activityKey,
    eventDefinitionKey,
    journeyVersion,
    showAlertToClose,
  };
  return (
    <CustomActivityContext.Provider value={value}>
      {window.location.hostname !== 'localhost' &&
        window.location.hostname !== '127.0.0.1' &&
        showAlertToClose && (
          <Overlay onClick={() => connection.trigger('destroy')}>
            <div className="message-wrap">{showAlertToClose}</div>
          </Overlay>
        )}
      {children}
    </CustomActivityContext.Provider>
  );
};

export default CustomActivityContextProvider;
